import { MoreOutlined } from '@ant-design/icons'
import { Styles } from '@types'
import { Button, Dropdown, Menu, Image, Table, TableColumnType, TablePaginationConfig, Tag } from 'antd'
import dayjs from 'dayjs'
import { Rentals } from 'gadjet-v2-types/dist/model'
import { CreditType, Pagination } from 'gadjet-v2-types/dist/type'
import { creditType } from 'gadjet-v2-types/dist/type/label'

import { RentalActionType } from '@pages/Authorized/Branch/RentalPage'

import ContentWrapper from '@components/atoms/ContentWrapper'

type Props = {
  loading: boolean
  total: number
  pagination: Pagination
  rentals: Rentals[]
  onAction: (action: RentalActionType, rentalId: number) => void
  onChangePagination: (pagination: Pagination) => void
}
export default function BranchRentalListTable({
  loading,
  total,
  pagination,
  rentals,
  onAction,
  onChangePagination,
}: Props): JSX.Element {
  const onChange = (_pagination: TablePaginationConfig) => onChangePagination({ ...pagination, ..._pagination })

  const columns: TableColumnType<Rentals>[] = [
    {
      key: 'imageId',
      dataIndex: 'imageId',
      title: '이미지',
      width: '120px',
      render: (_, { image }) => <Image style={styles.image} src={image?.uri || ''} alt="rental" />,
    },
    { key: 'name', dataIndex: 'name', title: '이름', width: '200px' },
    { key: 'description', dataIndex: 'description', title: '설명' },
    {
      key: 'price',
      dataIndex: 'price',
      title: '비용/30분',
      width: '150px',
      render: (price) => `${price} 크레딧`,
    },
    {
      key: 'rentalId',
      dataIndex: 'rentalId',
      title: '이용시간',
      width: '100px',
      render: (_, { startTime, endTime }) => {
        const isAllTime = startTime === '00:00' && endTime === '23:30'
        if (isAllTime) return <Tag color="blue">24시간 이용가능</Tag>
        return (
          <Tag color="green">
            {dayjs(startTime, 'HH:mm').format('HH:mm')} ~ {dayjs(endTime, 'HH:mm').add(30, 'minutes').format('HH:mm')}
          </Tag>
        )
      },
    },
    {
      key: 'weekendFlag',
      dataIndex: 'weekendFlag',
      title: '주말',
      width: '80px',
      render: (weekendFlag) => (weekendFlag ? <Tag color="blue">이용가능</Tag> : <Tag color="red">이용불가</Tag>),
    },
    {
      key: 'availableCreditType',
      dataIndex: 'availableCreditType',
      title: '크레딧',
      width: '100px',
      render: (availableCreditType: CreditType[]) =>
        availableCreditType.map((type) => <Tag key={type}>{creditType[type]}</Tag>),
    },
    {
      key: 'rentalId',
      dataIndex: 'rentalId',
      title: '',
      width: '80px',
      align: 'center',
      render: (rentalId) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="form" onClick={() => onAction('update', rentalId)}>
                수정
              </Menu.Item>
              <Menu.Item key="delete" onClick={() => onAction('delete', rentalId)}>
                제거
              </Menu.Item>
            </Menu>
          }
          placement="bottomRight"
          trigger={['click']}
        >
          <Button icon={<MoreOutlined />} size="large" type="text" />
        </Dropdown>
      ),
    },
  ]

  return (
    <ContentWrapper>
      <Table<Rentals>
        loading={loading}
        style={styles.table}
        scroll={{ x: true }}
        rowKey={({ rentalId }) => `${rentalId}`}
        dataSource={rentals}
        columns={columns}
        onChange={onChange}
        pagination={{
          total,
          position: ['bottomRight'],
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
      />
    </ContentWrapper>
  )
}

const styles: Styles = {
  table: { whiteSpace: 'pre-wrap', wordBreak: 'keep-all' },
  image: { width: '100px', height: '100px', objectFit: 'cover' },
}
